export default __webpack_public_path__ + "static/media/6photo(new).c1bf1a9e.jpg";